var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlumoBannerBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1081,
    viewBox: "0 0 1920 1081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c233d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c233d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.832,
    y1: -0.048,
    x2: 0.689,
    y2: 0.938,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134e58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c233d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_385",
    "data-name": "Rectangle 385",
    width: 1920,
    height: 216.627,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 1920,
    height: 1081,
    transform: "translate(-19029 -23533)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_386",
    "data-name": "Rectangle 386",
    width: 1281.243,
    height: 1275.339,
    fill: "#0b223e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2339",
    "data-name": "Group 2339",
    transform: "translate(19029 23533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2338",
    "data-name": "Group 2338"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 1920,
    height: 865,
    transform: "translate(-19029 -23533)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2331",
    "data-name": "Group 2331",
    transform: "translate(-19029 -22669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M960,216.627c382.552,0,725.823-83.822,960-216.627H0C234.176,132.8,577.446,216.627,960,216.627",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_38",
    "data-name": "Mask Group 38",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2337",
    "data-name": "Group 2337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M609.915,225.908q0,10.1-.989,20.147t-2.966,19.952q-1.971,9.911-4.908,19.573t-6.8,18.993q-3.863,9.325-8.632,18.235t-10.378,17.3q-5.621,8.4-12.03,16.2t-13.557,14.949q-7.149,7.14-14.967,13.546t-16.216,12.012q-8.4,5.613-17.317,10.372t-18.258,8.626q-9.333,3.863-19.01,6.8t-19.585,4.9q-9.92,1.963-19.975,2.954t-20.171.995q-10.106,0-20.165-.995t-19.975-2.954q-9.911-1.971-19.585-4.9t-19.016-6.8q-9.334-3.863-18.253-8.626t-17.317-10.372q-8.41-5.6-16.222-12.012T258.66,371.259q-7.149-7.149-13.558-14.949t-12.03-16.2q-5.621-8.392-10.384-17.3t-8.632-18.235q-3.863-9.333-6.8-18.993t-4.908-19.573q-1.971-9.9-2.96-19.952t-.989-20.147q0-10.1.989-20.147t2.96-19.952q1.972-9.911,4.908-19.573t6.8-18.993q3.872-9.325,8.632-18.235t10.384-17.3q5.613-8.4,12.03-16.2T258.66,80.557q7.149-7.14,14.961-13.546T289.842,55q8.4-5.613,17.317-10.372T325.412,36q9.342-3.863,19.016-6.8t19.585-4.9q9.911-1.971,19.975-2.96t20.165-.995q10.115,0,20.171.995t19.975,2.96q9.911,1.963,19.585,4.9t19.01,6.8q9.342,3.863,18.258,8.626T518.469,55q8.4,5.6,16.216,12.012t14.967,13.546q7.14,7.149,13.557,14.949t12.03,16.2q5.612,8.392,10.378,17.3t8.632,18.235q3.872,9.333,6.8,18.993t4.908,19.573q1.972,9.9,2.966,19.952t.989,20.147",
    transform: "translate(-19120.416 -23478.354)",
    fill: "#0b223e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2333",
    "data-name": "Group 2333",
    transform: "matrix(-0.766, -0.643, 0.643, -0.766, -17574.92, -22250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M1255.051,456.962q-1.73-5.963-4.042-11.73t-5.172-11.277q-2.864-5.509-6.255-10.714t-7.278-10.053q-3.885-4.847-8.231-9.289t-9.1-8.439q-4.759-4-9.884-7.51t-10.577-6.5q-5.444-2.988-11.159-5.436T1171.71,371.7q-5.928-1.872-12.01-3.157t-12.261-1.964q-6.176-.679-12.4-.752t-12.407.464q-6.194.537-12.3,1.677t-12.08,2.877q-5.969,1.736-11.738,4.042t-11.285,5.176q-5.515,2.864-10.722,6.255t-10.061,7.278q-4.848,3.885-9.293,8.227t-8.443,9.1q-4,4.753-7.51,9.88t-6.5,10.565q-2.988,5.444-5.432,11.155t-4.314,11.632q-1.872,5.922-3.153,12t-1.956,12.25q-.679,6.17-.748,12.383t.472,12.4q.543,6.188,1.689,12.289t2.885,12.065q2.751,9.435,5.023,18.992t4.05,19.221q1.783,9.665,3.07,19.4t2.082,19.536q.791,9.789,1.082,19.61t.091,19.642q-.207,9.825-.913,19.622t-1.905,19.551q-1.2,9.754-2.9,19.429t-3.881,19.256q-2.185,9.577-4.853,19.036t-5.814,18.764q-3.147,9.305-6.762,18.445t-7.688,18.079q-4.074,8.939-8.6,17.666t-9.486,17.205q-4.96,8.485-10.344,16.705t-11.183,16.154q-5.792,7.941-11.986,15.572T928.462,894.36q-6.571,7.309-13.505,14.277t-14.214,13.572q-7.28,6.607-14.887,12.832T870.34,947.106q-7.912,5.833-16.111,11.262t-16.662,10.427q-8.461,5.007-17.17,9.573t-17.634,8.687q-8.927,4.121-18.055,7.782t-18.425,6.857q-9.3,3.194-18.748,5.916t-19.028,4.956q-9.577,2.238-19.252,3.983t-19.433,3q-9.754,1.258-19.559,2.015t-19.634,1.019q-9.831.26-19.661.024t-19.642-.972q-9.807-.738-19.563-1.968t-19.437-2.96q-9.683-1.724-19.264-3.936t-19.036-4.912q-9.459-2.7-18.764-5.869t-18.445-6.814q-9.134-3.643-18.071-7.743t-17.654-8.644q-8.721-4.552-17.193-9.534t-16.686-10.388q-8.213-5.408-16.139-11.222T395.524,935.62q-7.617-6.206-14.914-12.8t-14.245-13.541q-6.949-6.949-13.541-14.241t-12.8-14.914q-6.211-7.617-12.025-15.54t-11.218-16.131q-5.408-8.207-10.388-16.682t-9.526-17.182q-4.54-8.715-8.636-17.646T280.5,778.887q-3.631-9.128-6.8-18.429t-5.861-18.752q-2.686-9.447-4.9-19.024t-3.928-19.244q-1.718-9.677-2.94-19.421t-1.952-19.547q-.732-9.8-.96-19.618T253.2,625.2q.272-9.819,1.039-19.614t2.031-19.536q1.269-9.742,3.027-19.409t4-19.232q2.25-9.565,4.979-19t5.936-18.729q3.212-9.288,6.884-18.4t7.806-18.028q4.133-8.915,8.711-17.611t9.6-17.146q5.019-8.449,10.455-16.635t11.289-16.083q5.845-7.9,12.088-15.493t12.86-14.859q6.619-7.262,13.6-14.186t14.3-13.482q7.321-6.554,14.969-12.734t15.6-11.962q7.953-5.786,16.186-11.155t16.729-10.321q8.5-4.948,17.233-9.459t17.689-8.573q8.957-4.062,18.107-7.664t18.469-6.739q9.323-3.135,18.788-5.794t19.059-4.83q9.589-2.173,19.28-3.861t19.449-2.873q6.164-.756,12.218-2.106t11.954-3.291q5.893-1.937,11.573-4.444t11.081-5.554q5.408-3.047,10.486-6.613t9.785-7.6q4.706-4.039,8.994-8.526t8.113-9.364q3.832-4.877,7.16-10.112t6.133-10.762q2.8-5.532,5.046-11.313t3.917-11.754q1.671-5.969,2.748-12.076t1.547-12.289q.472-6.182.339-12.383t-.882-12.352q-.738-6.158-2.082-12.21T698.216,87.1q-1.931-5.893-4.428-11.569T688.25,64.445q-3.041-5.4-6.6-10.482t-7.593-9.793q-4.039-4.706-8.518-9t-9.356-8.124q-4.877-3.832-10.112-7.172t-10.762-6.144q-5.532-2.81-11.313-5.066T612.237,4.733q-5.975-1.677-12.084-2.767T587.852.4q-6.188-.484-12.391-.362T563.09.895q-14.4,1.748-28.707,4.149T505.9,10.487q-14.188,3.047-28.215,6.727t-27.88,8q-13.846,4.316-27.487,9.25T395.272,44.945q-13.4,5.55-26.538,11.7T342.755,69.527q-12.842,6.737-25.369,14.048T292.678,98.753q-12.181,7.871-23.991,16.284t-23.232,17.347q-11.419,8.939-22.417,18.386t-21.563,19.378q-10.563,9.931-20.665,20.335t-19.717,21.248q-9.618,10.846-18.736,22.118t-17.713,22.94q-8.6,11.673-16.654,23.72T92.426,304.961q-7.5,12.4-14.438,25.129T64.708,355.844q-6.353,13.025-12.1,26.329t-10.9,26.849q-5.143,13.551-9.667,27.314t-8.416,27.727q-3.9,13.958-7.156,28.077T10.6,520.513q-2.61,14.253-4.578,28.608T2.739,577.907q-1.311,14.43-1.968,28.9T.114,635.773c0,352.643,287.176,639.614,640.173,639.614S1280.46,988.5,1280.46,635.86a636.034,636.034,0,0,0-25.408-178.9",
    transform: "translate(0.335 0.038)",
    fill: "#0b223e"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumoBannerBg);
export default __webpack_public_path__ + "static/media/alumo-banner-bg.03313d58cbca928b6c70923676fd0aa3.svg";
export { ForwardRef as ReactComponent };